module.exports = __webpack_public_path__ + "static/img/01.58f6c99.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/docs/05/01.jpg
// module id = wyRM
// module chunks = 1